import { render, staticRenderFns } from "./licensedig.vue?vue&type=template&id=1e5afa85"
import script from "./licensedig.vue?vue&type=script&lang=js"
export * from "./licensedig.vue?vue&type=script&lang=js"
import style0 from "./licensedig.vue?vue&type=style&index=0&id=1e5afa85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports